// Os números pelos quais um chamado pode ser procurado.
//
// Um chamado tem três, e eles não são sinônimos:
//
//   `number`           o que a TELA mostra -- card do kanban, coluna de
//                      protocolo, título. Numeração por tenant, criada em
//                      28/08/2026 (`AddPerTenantTicketNumber`).
//   `id`              a chave primária global. Igual ao `number` só para o
//                      acervo que existia no backfill; diverge dali em diante.
//   `movidesk_number`  o número no sistema antigo, no acervo importado.
//
// Até 27/10/2026 a busca da listagem montava a string de procura só com o
// `id`. Quem digitava o número que estava LENDO na tela não achava nada —
// e sem erro: a lista voltava vazia, como se o chamado não existisse
// (Gisele, 27/10: "a busca por assunto ou pelo registro do cliente funciona;
// a busca pelo número do ticket, não").

/**
 * Os números do chamado, prontos para entrar numa busca por texto.
 *
 * @param {object} chamado linha de chamado como a API devolve
 * @returns {string} os números separados por espaço, sem os que faltam
 */
export function numerosDoChamado(chamado) {
    if (!chamado) return '';

    return [chamado.number, chamado.id, chamado.movidesk_number]
        .filter((n) => n != null && n !== '')
        .map(String)
        .join(' ');
}

export default numerosDoChamado;
